/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef } from 'react';
import ErrorBoundary from '@/app/common/components/ErrorBoundary';

type HtmlInjectorProps = {
  htmlString: string | null;
};
const HtmlInjector = ({ htmlString }: HtmlInjectorProps) => {
  const containerRef: any = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.innerHTML = htmlString;

      // Execute all scripts inside the injected content
      const scripts = containerRef.current.querySelectorAll('script');
      scripts.forEach((oldScript: any) => {
        const newScript = document.createElement('script');
        newScript.text = oldScript.textContent; // Copy inline script content
        newScript.async = oldScript.async;
        newScript.defer = oldScript.defer;

        // Copy attributes like src, type, etc.
        [...oldScript.attributes].forEach((attr) => newScript.setAttribute(attr.name, attr.value));

        oldScript.replaceWith(newScript); // Replace old <script> with new one
      });
    }
  }, [htmlString]); // Re-run if htmlString changes

  return (
    <ErrorBoundary id="HtmlInjector">
      <div ref={containerRef} />
    </ErrorBoundary>
  );
};

export default HtmlInjector;
